import { render, staticRenderFns } from "./searchOrder.vue?vue&type=template&id=ddbb4ba4&scoped=true&"
import script from "./searchOrder.vue?vue&type=script&lang=js&"
export * from "./searchOrder.vue?vue&type=script&lang=js&"
import style0 from "./searchOrder.vue?vue&type=style&index=0&id=ddbb4ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbb4ba4",
  null
  
)

export default component.exports